
import Vue from 'vue';

export default Vue.extend({
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    label: { type: String, required: true },
  },
  data() {
    return {};
  },
  mounted() {},
});
